import { render, staticRenderFns } from "./BannerLabel.vue?vue&type=template&id=0a1d9a2a&scoped=true&"
import script from "./BannerLabel.vue?vue&type=script&lang=js&"
export * from "./BannerLabel.vue?vue&type=script&lang=js&"
import style0 from "./BannerLabel.vue?vue&type=style&index=0&id=0a1d9a2a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a1d9a2a",
  null
  
)

export default component.exports